import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { AuthService } from './auth-guard/auth.service';
import { DriverPresenceService } from './driver-presence.service';
import { CommonService } from './service/common.service';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  private readonly skipAuthEndpoints: string[] = [
    'v1/media/content',
    'v1/auth/document-upload/info',
    'v1/auth/document-upload/licence/upload',
    'v1/auth/document-upload/profile-image/upload',
    'v1/driver/equipmentDocument/upload/driver/scan',
    'v1/driver/equipmentDocument/upload/driver/scan/ifta'
  ];

  constructor(
    public authService: AuthService,
    private driverPresence: DriverPresenceService,
    public router: Router,
    private commonService: CommonService
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authRequest = req;

    // Attach token to every HttpClient request (as long as a token exists),
    // instead of relying on `LoginStatus` (which can be stale if storage keys change).
    const token = this.authService.getToken() ?? this.authService.rememberMeToken();
    const shouldSkipAuth = this.skipAuthEndpoints.some((endpoint) =>
      req.url.includes(endpoint)
    );
    if (!shouldSkipAuth && !this.commonService.isEmpty(token) && !req.headers.has('Authorization')) {
      const headers = req.headers.set('Authorization', `Bearer ${token}`);
      authRequest = req.clone({ headers });
    }

    return next.handle(authRequest).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
        }
      }),
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          console.error('error status = ', error.status);
          const isMedia = req.url.includes('/v1/media/content');
          const isPresence = req.url.includes('/v1/driver/presence/');
          // Media is HMAC-gated; a 401 here must not force logout of the driver session.
          // Presence heartbeats must not loop-logout on 401.
          if (error.status == 401 && !isMedia && !isPresence) {
              this.driverPresence.stopLocal();
              this.authService.logout();
              this.router.navigate(['/auth/login']);
          }
        }
        return throwError(() => error);
      })
    );

  }
}
